// import React from "react";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css"; // Import the default styles

// const ToastManager = () => {
//   return (
//     <ToastContainer
//       position="top-center" // Better placement for mobile
//       autoClose={2000} // Automatically close after 3 seconds
//       hideProgressBar // Hide the progress bar for a cleaner look
//       newestOnTop={true} // Display the newest notification on top
//       closeOnClick // Allow to close by clicking
//       rtl={false} // Set to true for right-to-left languages
//       pauseOnFocusLoss={false} // Prevent toasts from pausing on tab switch
//       draggable={false} // Disable dragging for mobile
//       limit={1} // Limit to 1 notification at a time
//       toastClassName="toast-mobile" // Use custom CSS for mobile
//     />
//   );
// };

// export default ToastManager;



// components/ToastManager.jsx
import React from "react";
import { Toaster } from "sonner"; // 👈 New import

const ToastManager = () => {
  return (
    <Toaster
      position="top-center" // Top-center like your existing setup
      richColors // Enable Sonner’s modern color styling
      expand={true} // Animates smoothly on mobile/stacked toasts
      duration={1000} // Toast auto close duration
    />
  );
};

export default ToastManager;
